import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _PerformanceCriteria } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";


interface Props {
    IDFunctionalCompetence: number;
}

export const PerformanceCriteria = ({ IDFunctionalCompetence }: Props) => {

    const PerformanceCriteria = useDataBean(_PerformanceCriteria);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDFunctionalCompetence])

    const getLista = () => {

        PerformanceCriteria.instance.getPerformanceCriteriaCatalog(IDFunctionalCompetence).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        PerformanceCriteria.setBean({
            IDFunctionalCompetence: IDFunctionalCompetence
        });
        setModal({ ...modal, "name": "Agregar Macro Proceso", "view": true });
    }

    const deleteItem = () => {
        PerformanceCriteria.instance.deletePerformanceCriteria(PerformanceCriteria.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
       //console.log(PerformanceCriteria.bean);
        PerformanceCriteria.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPerformanceCriteria', visible: true },
        { title: 'Clasificación', property: 'Classifier', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo=" Criterios de Desempeño ">
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={PerformanceCriteria.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Clasificación</label>
                                <input type="text" name="Classifier" className="form-control" value={PerformanceCriteria.bean.Classifier} onChange={PerformanceCriteria.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-12">
                                <label>Description</label>
                                <textarea name="Description" className="form-control" value={PerformanceCriteria.bean.Description} onChange={PerformanceCriteria.handleChange} />
                            </div>

                        </div>
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}